export default function getResource(label) {
    const resources = {
        savedForLaterTitle: 'Saved For Later',
        viewAll: 'View all',
        remove: 'Remove',
        moveToBasket: 'Move to Basket',
        moved: 'Moved',
        limitExceededTitle: 'Limit Reached for This Item',
        maxItemsReachedMessage: 'Max number of products saved. To add more, please remove products first.',
        ok: 'OK',
        genericErrorTitle: 'Error',
        genericErrorMessage: 'An error occurred. Please try again.',
        gotIt: 'Got It',
        itemShip: 'This item is not available in your country.'
    };

    return resources[label];
}
